import { render, staticRenderFns } from "./IssueCards.vue?vue&type=template&id=5162e5a2&scoped=true&"
import script from "./IssueCards.vue?vue&type=script&lang=js&"
export * from "./IssueCards.vue?vue&type=script&lang=js&"
import style0 from "./IssueCards.vue?vue&type=style&index=0&id=5162e5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162e5a2",
  null
  
)

export default component.exports